import React, { useEffect, useState } from 'react';
import ajaxReports from '../../utils/remote/ajaxReports';



const OccupancyRateContext = React.createContext({});
export const OccupancyRateConsumer = OccupancyRateContext.Consumer;

export const OccupancyRateProvider = (props) => {

    const [occupancyRateList, setVehicleOccupancyRate] = useState(false);
    const [loading, setLoading] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false);
    const [metaData, setMetaData] = useState(null);
    const [title, setTitle] = useState("Occupancy Rate");
    const [currentPage, setCurrentPage] = useState(1);
    const [mounted, setMounted] = useState(false);
    const [searchFilter, setSearchFilter] = useState({});

    useEffect(()=>{
    if(mounted){
      getVehicleOccupancyRate();
    }
  }, [currentPage])
    

    const getVehicleOccupancyRate = async (refresh = false, filterData = null) => {
    setMounted(true);
    if (loading) return;

    if (refresh) {
        setVehicleOccupancyRate({}); // Reset to empty object
        setMetaData(null);
        setCurrentPage(1);
    }

    const data = {
        "street_id": filterData ? filterData.street_id : searchFilter?.street_id,
        "date_from": filterData ? filterData.date_from : searchFilter?.date_from,
        "date_to": filterData ? filterData.date_to : searchFilter?.date_to,
        "location_id": filterData ? filterData.location_id : searchFilter?.location_id,
        "page": refresh ? 1 : currentPage
    };

    setLoading(true);
    const server_response = await ajaxReports.fetchOccupancyRate(data);
    setLoading(false);

    if (server_response.status === 'OK') {
        const newReport = server_response.details.content.data.report;
        const title = server_response.details.content.data.title;
        const meta = server_response.details.content.meta;

        setTitle(title);
        setMetaData(meta);

        if (refresh || !occupancyRateList || Object.keys(occupancyRateList).length === 0) {
            setVehicleOccupancyRate(newReport); // On refresh, overwrite
        } else {
            setVehicleOccupancyRate(prev => ({
                ...prev,
                ...newReport // Merge new locations with existing
            }));
        }

        setCurrentPage(meta.page); // Update page
    } else {
        setVehicleOccupancyRate("404");
    }
};


     const filterData = (options) => {
       const data = {
            "street_id": options.selectedValue,
            "date_from": options.dateFrom,
            "date_to": options.dateTo,
            "location_id": options.selectedValue6,
            "page": 1
        };
       setSearchFilter(data);
       getVehicleOccupancyRate(true, data);
    }

  const loadMore = async () => {
     setCurrentPage(currentPage + 1);   
  };



    return (
        <OccupancyRateContext.Provider value={{
            occupancyRateList,
            loading,
            loadingMore,
            title,
            metaData,
            currentPage,
            loadMore,
            filterData,
            getVehicleOccupancyRate,
        }}>
            {props.children}
        </OccupancyRateContext.Provider>
    );


}
export default OccupancyRateContext;